import { combineReducers } from 'redux';
import { setAlert, setError, setHasValidated, setSignedIn, setUser } from './auth';
import { setCode } from './core';
import { setFlow } from './flow';
import { setLanguage } from './locale';
import { setReturnTo } from './return';
import { applyTheme, toggleMode } from './style';

const reducers = combineReducers({
  alert: setAlert,
  code: setCode,
  error: setError,
  flow: setFlow,
  isSignedIn: setSignedIn,
  hasValidated: setHasValidated,
  language: setLanguage,
  mode: toggleMode,
  returnTo: setReturnTo,
  theme: applyTheme,
  user: setUser
});

export default reducers;
